import { WebPlugin } from '@capacitor/core';
const UNIMPLEMENTED_TEXT = 'Not implemented on web.';
export class FingerprintWeb extends WebPlugin {
    connect() {
        throw this.unimplemented(UNIMPLEMENTED_TEXT);
    }
    disconnect() {
        throw this.unimplemented(UNIMPLEMENTED_TEXT);
    }
    capture(options) {
        console.log(options);
        throw this.unimplemented(UNIMPLEMENTED_TEXT);
    }
    match(options) {
        console.log(options);
        throw this.unimplemented(UNIMPLEMENTED_TEXT);
    }
    init(options) {
        console.log(options);
        throw this.unimplemented(UNIMPLEMENTED_TEXT);
    }
}
//# sourceMappingURL=web.js.map